import { useEffect } from 'react';
import { useSite } from '../context/SiteContext';

/**
 * usePageReady
 * ------------
 * Call this at the top of any page that is a transition target
 * (ExhibitorBoothPage, PlenaryPage, ExhibitorsPage).
 *
 * It fires pageReadyRef.current() after the first paint, telling
 * PublicPage that the page is visible and the transition overlay can fade out.
 *
 * Uses a double requestAnimationFrame to ensure the browser has actually
 * painted the page before signalling ready.
 */
const usePageReady = () => {
  const { pageReadyRef } = useSite();

  useEffect(() => {
    let raf1, raf2;
    raf1 = requestAnimationFrame(() => {
      raf2 = requestAnimationFrame(() => {
        pageReadyRef?.current?.();
      });
    });
    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, []); // only on mount
};

export default usePageReady;
